import React from "react";
import { ChipsBottomSheet } from "./ChipsBottomSheet";
import styled from "styled-components";
import { MissionsBottomSheetContent } from "./MissionsBottomSheetContent";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";

const Close = styled.div`
  position: absolute;
  top: ${calc(14)};
  right: ${calc(8)};
  padding: ${calc(8)};
  cursor: pointer;
  transition-property: all;
  transition: 0.1s ease-in-out;

  &:active {
    scale: 0.95;
    opacity: 0.8;
  }
`;

export function MissionsBottomSheet(props) {
  return ChipsBottomSheet(
    props,
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          height: calc(67),
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            color: "#212121",
            textAlign: "center",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(18),
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
          }}
        >
          도전권 모으기
        </div>
        <Close
          onClick={() => {
            props.dismiss();
          }}
        >
          <img
            style={{
              width: calc(20),
              height: calc(20),
            }}
            src="/games/fruits/assets/ic-title-back.png"
          />
        </Close>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: calc(16),
          width: calc(328),
        }}
      >
        <div
          id="missions-container"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: calc(16),
            width: calc(328),
          }}
        >
          <MissionsBottomSheetContent {...props} />
        </div>

        <div
          style={{
            width: calc(328),
            height: calc(1),
            margin: `${calc(4)} 0`,
            background: "#EEE",
          }}
        ></div>

        <div
          style={{
            width: calc(328),
            color: "#888",
            alignItems: "flex-start",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(13),
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "150%",
          }}
        >
          <span>
            도전권은 <font color="#FF514E">최대 3개,</font> 스페셜 도전권은{" "}
            <font color="#FF514E">최대 5개까지</font> 보유할 수 있어요.
            <br />
            도전권을 사용한 후에 추가로 받아보세요!
            <br />
            <font color="#FF514E">본인에게는 공유가 불가</font>하니 친구에게
            공유해주세요!
          </span>
        </div>
      </div>
    </div>,
  );
}
